
export const SUN_EDITOR_OPTIONS_AI_INSIGHTS = {
    mode: 'classic',
    katex: 'window.katex',
    height: 200,
    fontSize: [8, 10, 14, 18, 24, 36],
    fontSizeUnit: 'px',
    formats: ['p', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    lineHeights: [
         { text: 'Single', value: 1 },
         { text: 'Double', value: 2 },
    ],
    textStyles: [
         {
              name: 'Code',
              tag: 'code',
         },
    ],
    buttonList: [
         [
              'undo',
              'redo',
              'fontSize',
              'formatBlock',
              'bold',
              'underline',
              'italic',
              'list',
              'link',
              'fullScreen',
         ],
    ],
};

export const ACCORDION_TYPES_INTELLIGENCE = {
    BUSINESS_INFO: 'business-information',
    AI_CREDITS: 'ai-credits',
    AVAILABLE_MODELS: 'available-models',
    AI_INSIGHTS: 'ai-insights',
    INTENT_ANALYSIS: 'intent_analysis',
    TALK_TO_DATA: 'talk-to-data',
};

export const ACCORDION_TYPES_INTENT_ANALYSIS = {
     MANAGE_INTENT_RULES: 'manage-intent-rules',
     CLASSIFICATION_DATA_SETS: 'classification-data-sets',
     MANAGE_PROPERTIES: 'manage-properties'
};

export const TRIGGER_TYPE = {
     SCHEDULE: 'schedule',
     MANUAL_PREVIEW: 'manual_preview',
     MANUAL_RUN: 'manual_run',
     RERUN: 'rerun',
};

// LLM Provider constants matching server-side
export const LLM_PROVIDERS = {
     XAI: 'X.AI',
     GROQ: 'Groq',
};
